import type { IconButtonProps } from '@chakra-ui/react';
import { IconButton } from '@chakra-ui/react';

interface SocialIconProps extends IconButtonProps {
  children: React.ReactNode;
  href?: string;
  target?: string;
}

export function SocialIcon({ children, ...rest }: SocialIconProps) {
  return (
    <IconButton
      variant="unstyled"
      boxSize="xs"
      colorScheme="gray"
      sx={{
        svg: {
          transitionProperty: 'inherit',
          transitionDuration: 'inherit',
          color: 'gray.600',
        },
      }}
      {...rest}
    >
      {children}
    </IconButton>
  );
}
